import CloseIcon from "@mui/icons-material/Close";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import * as MUI from "@mui/material";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { findClinicsWithMissingData } from "../utils/findMissingClinicData";

function MissingDataDialog({ open, entries, onClose, onEditClinic }) {
  const { t } = useTranslation();
  const theme = MUI.useTheme();
  const fullScreen = MUI.useMediaQuery(theme.breakpoints.down("md"));

  return (
    <MUI.Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: { borderRadius: fullScreen ? 0 : 4 } }}
    >
      <MUI.DialogTitle>
        <MUI.Stack direction="row" alignItems="center" justifyContent="space-between">
          {t("ClinicsMissingDataTitle")}
          <MUI.IconButton onClick={onClose} size="small">
            <CloseIcon fontSize="small" />
          </MUI.IconButton>
        </MUI.Stack>
      </MUI.DialogTitle>
      <MUI.DialogContent>
        <MUI.List disablePadding>
          {entries.map(({ clinic, missingLabels }) => (
            <MUI.ListItem
              key={clinic.id}
              divider
              secondaryAction={
                <MUI.Tooltip title={t("Edit")}>
                  <MUI.IconButton size="small" onClick={() => onEditClinic(clinic.id)}>
                    <EditOutlinedIcon fontSize="small" />
                  </MUI.IconButton>
                </MUI.Tooltip>
              }
            >
              <MUI.ListItemText
                primary={clinic.title}
                secondaryTypographyProps={{ component: "div" }}
                secondary={
                  <MUI.Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap sx={{ mt: 0.5 }}>
                    {missingLabels.map((label) => (
                      <MUI.Chip key={label} size="small" color="warning" label={t(label)} />
                    ))}
                  </MUI.Stack>
                }
              />
            </MUI.ListItem>
          ))}
        </MUI.List>
      </MUI.DialogContent>
    </MUI.Dialog>
  );
}

export default function MissingDataAlert({ pendingRows, onEditClinic }) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const entries = useMemo(() => findClinicsWithMissingData(pendingRows), [pendingRows]);

  if (entries.length === 0) return null;

  return (
    <>
      <MUI.Alert
        severity="warning"
        action={
          <MUI.Button color="inherit" size="small" onClick={() => setIsOpen(true)}>
            {t("Details")}
          </MUI.Button>
        }
      >
        {t("ClinicsMissingDataAlert", { count: entries.length })}
      </MUI.Alert>
      <MissingDataDialog
        open={isOpen}
        entries={entries}
        onClose={() => setIsOpen(false)}
        onEditClinic={(clinicId) => {
          setIsOpen(false);
          onEditClinic(clinicId);
        }}
      />
    </>
  );
}
